module.exports = __webpack_public_path__ + "static/media/banner-rimula.a994ac17.png";